export default "__VITE_ASSET__Cg56ABvF__"